module.exports = __webpack_public_path__ + "assets/img/busy_2.6f04c287.png";